import { getCurrentUser } from '@/services/__mocks__/helpers'
import { mockFlag } from '@/utils/mock'
import { APIFailureWrapper } from '@/utils/mock'
import {
  integrations,
  userIntegrations,
} from '@/modules/integrations/mock/integrationsSeeds.js'

const integrationsRoutes = [
  mockFlag(
    {
      method: 'get',
      url: '/integrations',
      result: () => {
        const response = integrations

        return APIFailureWrapper({
          content: response,
          errorMessage: 'Erro na listagem de integrações',
        })
      },
    },
    'on'
  ),
  mockFlag(
    {
      method: 'get',
      url: '/integrations/user-integrations',
      result: () => {
        let response = []
        const currentUser = getCurrentUser()

        response = userIntegrations.find(
          (integration) => integration.user_id == currentUser.user.id
        )['integrations']

        return APIFailureWrapper({
          content: response,
          errorMessage: 'Erro na listagem de integrações do usuário',
        })
      },
    },
    'on'
  ),
  mockFlag(
    {
      method: 'post',
      url: '/google-api/calendar',
      result: () => {
        const googleCalendar = integrations.find(
          (integration) => integration.name === 'google_calendar'
        )
        const currentUser = getCurrentUser()

        userIntegrations.forEach((integration) => {
          if (integration.user_id == currentUser.user.id) {
            integration.integrations.push(googleCalendar)
          }
        })

        return APIFailureWrapper({
          content: null,
          errorMessage: 'Erro na adição de integração Google Calendar',
        })
      },
    },
    'on'
  ),
  mockFlag(
    {
      method: 'post',
      url: '/google-api/save-token',
      result: () => {
        return APIFailureWrapper({
          content: null,
          errorMessage:
            'Erro no envio do token de integração do Google Calendar',
        })
      },
    },
    'on'
  ),
  mockFlag(
    {
      method: 'patch',
      url: '/integrations/toggle',
      result: ({ requestBody }) => {
        const requestObj = JSON.parse(requestBody)
        const currentUser = getCurrentUser()

        userIntegrations.forEach((userIntegration) => {
          if (userIntegration.user_id == currentUser.user.id) {
            userIntegration.integrations.forEach((integration) => {
              if (integration.id == requestObj.integration_id) {
                integration.is_active = !integration.is_active
              }
            })
          }
        })

        return APIFailureWrapper({
          content: { message: 'Integration enabled successfully.' },
          errorMessage: 'Erro na edição de integração',
        })
      },
    },
    'on'
  ),
]

export { integrationsRoutes }
